import React from "react"

export const withLightbox = WrappedComponent => {
  return class extends React.Component {
    state = {
      toggle: false,
      init: false,
      selectedDropdown: 0,
      selected: 0,
      selectedAdditional: 0,
    }

    toggleLightbox = () => {
      this.setState({ toggle: !this.state.toggle })
    }

    setInit = initValue => {
      this.setState({ init: initValue })
    }

    setSelected = i => this.setState({ selected: i })

    setSelectedDropdown = i => this.setState({ selectedDropdown: i })

    setSelectedAdditional = i => this.setState({ selectedAdditional: i })

    render() {
      return (
        <WrappedComponent
          toggle={this.state.toggle}
          init={this.state.init}
          selected={this.state.selected}
          toggleLightbox={this.toggleLightbox}
          setSelected={this.setSelected}
          setInit={this.setInit}
          setSelectedDropdown={this.setSelectedDropdown}
          dropdownSelected={this.state.selectedDropdown}
          setSelectedAdditional={this.setSelectedAdditional}
          selectedAdditional={this.state.selectedAdditional}
          {...this.props}
        />
      )
    }
  }
}
